export default __webpack_public_path__ + "static/media/bubble_bg.0f50158b.png";